import { render, staticRenderFns } from "./MemberCardView.vue?vue&type=template&id=5dc1e4f9&scoped=true"
import script from "./MemberCardView.vue?vue&type=script&lang=ts"
export * from "./MemberCardView.vue?vue&type=script&lang=ts"
import style0 from "./MemberCardView.vue?vue&type=style&index=0&id=5dc1e4f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc1e4f9",
  null
  
)

export default component.exports